import { HandsetService } from '../../../core/services/handset.service';
import { BehaviorSubject } from 'rxjs';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { UploadedFile } from '../../../liabilities/models/uploaded-file.model';
import { HttpClient } from '@angular/common/http';

@Component({
standalone: false,
  selector: 'app-document-preview',
  templateUrl: './document-preview.component.html',
  styleUrls: ['./document-preview.component.scss'],
})
export class DocumentPreviewComponent implements OnInit, OnChanges {

  @Input() public fileAsArrayBuffer: ArrayBuffer;
  @Input() public files: UploadedFile[] = [];
  @Input() public url?: any;
  @Input() public path?: string;
  @Input() public readonly?: boolean = false;
  @Input() remove: (index: number) => void;
  @Output() public hidePreview = new EventEmitter();

  public currentFile: BehaviorSubject<UploadedFile>;

  public indexTab: number[];
  public src: Uint8Array;
  public base64Src: string;

  public activeIndex = 0;
  // public readonly config: SwiperConfigInterface = {
  //   direction: 'horizontal',
  //   navigation: true,
  //   zoom: {
  //     maxRatio: 3,
  //     toggle: true,
  //   },
  // };

  constructor(public handsetService: HandsetService, private http: HttpClient) {
  }

  public ngOnInit(): void {
    this.initFile();
  }

  public ngOnChanges(): void {
    this.indexTab = Array.from(this.files.keys());
  }

  public removeFile(): void {
    const file = this.currentFile.value;

    const index = this.files?.indexOf(file);
    this.remove(index);
    this.close();
  }

  public close(): void {
    this.hidePreview.next(true);
  }

  public onIndexChange(swiperIndex: number): void {
    const file = this.findElementWithIndex(swiperIndex);
    this.currentFile.next(file);
  }

  private initFile(): void {
    if (this.fileAsArrayBuffer !== undefined && this.fileAsArrayBuffer === null) {
      this.base64Src = this.convertToBase64(this.fileAsArrayBuffer);
    } else {
      this.http.get(this.path, { responseType: 'arraybuffer' })
        .subscribe((response: ArrayBuffer) => {
            this.base64Src = this.convertToBase64(response);
            this.src = new Uint8Array(response);
          },
          (error) => {
            console.error('Błąd podczas pobierania pliku:', error);
          },
        );
    }
  }

  private convertToBase64(buffer: ArrayBuffer): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  private findElementWithIndex(index: number): UploadedFile {
    return this.files.find((elem, arrIndex) => index === arrIndex);
  }
}
